import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwapHorizIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swap_horiz"}/>
}
